import { WithDatePicker } from "components/UI/Table/UI/InteractiveCell/components/WithDatePicker.tsx";
import { WithInput } from "components/UI/Table/UI/InteractiveCell/components/WithInput.tsx";
import { WithInputNumber } from "components/UI/Table/UI/InteractiveCell/components/WithInputNumber.tsx";
import { WithMoney } from "components/UI/Table/UI/InteractiveCell/components/WithMoney.tsx";
import { WithPayoutFormula } from "components/UI/Table/UI/InteractiveCell/components/WithPayoutFormula.tsx";
import { WithSearchableSelect } from "components/UI/Table/UI/InteractiveCell/components/WithSearchableSelect.tsx";
import { WithSelect } from "components/UI/Table/UI/InteractiveCell/components/WithSelect.tsx";
import { WithTextArea } from "components/UI/Table/UI/InteractiveCell/components/WithTextArea.tsx";

export const InteractiveCell = {
    Input: WithInput,
    NumberInput: WithInputNumber,
    Money: WithMoney,
    Select: WithSelect,
    TextArea: WithTextArea,
    DatePicker: WithDatePicker,
    PayoutFormula: WithPayoutFormula,
    ...WithSearchableSelect,
};
